import { Component, Input } from '@angular/core';
import { ProductVariantReserved } from 'src/app/admin-api';
import { ProductVariantStock } from 'src/app/models';
import { TableColumn } from '../table';

@Component({
  selector: 'app-product-stock',
  templateUrl: './product-stock.component.html',
  styleUrls: ['./product-stock.component.scss']
})
export class ProductStockComponent {
  @Input()
  products:
    | Array<
        ProductVariantStock & {
          reservedAcquisition?: number;
          reservedFidelization?: number;
        }
      >
    | undefined;

  @Input()
  productId: number | undefined;

  @Input()
  reservation: ProductVariantReserved[];

  cols: Array<TableColumn> = [
    new TableColumn('Id', 'productVariantId'),
    new TableColumn('InternalEAN', 'internalEAN'),
    new TableColumn('Variante', 'productVariantName'),
    new TableColumn.Builder()
      .setHeader('Estoque aquisição')
      .setField('inStockAcquisition')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build(),
    new TableColumn.Builder()
      .setHeader('Reserva aquisição')
      .setField('reservedAcquisition')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build(),
    new TableColumn.Builder()
      .setHeader('Estoque fidelização')
      .setField('inStockFidelization')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build(),
    new TableColumn.Builder()
      .setHeader('Reserva fidelização')
      .setField('reservedFidelization')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build(),
    new TableColumn.Builder()
      .setHeader('Estoque res. marketing')
      .setField('inStockReserveMarketing')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build(),
    new TableColumn.Builder()
      .setHeader('Estoque influencer')
      .setField('inStockInfluencerB4A')
      .setFilter(false)
      .setType('formattedInteger')
      .setStyleClass('text-right')
      .build()
  ];
  dropdownFilters = {
    type: [
      { label: 'Todas', value: 'all' },
      { label: 'Troca', value: 'Trade' },
      { label: 'Brinde', value: 'Gift' },
      { label: 'Reenvio', value: 'Resend' },
      { label: 'Incentivo para influencer', value: 'IncentiveInfluencer' }
    ]
  };
  columnsDiplayed: Array<TableColumn>;

  constructor() {
    this.columnsDiplayed = [...this.cols];
  }

  changeColumns($event: Array<TableColumn>): void {
    delete this.columnsDiplayed;
    setTimeout(() => {
      this.columnsDiplayed = $event;
    }, 1000);
  }

  get totalAcquisiton(): number {
    return (
      this.products?.reduce((sum, s) => (sum += s.inStockAcquisition), 0) || 0
    );
  }

  get totalReservedAcquisiton(): number {
    return (
      this.products?.reduce((sum, s) => (sum += s.reservedAcquisition), 0) || 0
    );
  }

  get totalFidelization(): number {
    return (
      this.products?.reduce((sum, s) => (sum += s.inStockFidelization), 0) || 0
    );
  }

  get totalReservedFidelization(): number {
    return (
      this.products?.reduce((sum, s) => (sum += s.reservedFidelization), 0) || 0
    );
  }

  get totalReserveMarketing(): number {
    return (
      this.products?.reduce(
        (sum, s) => (sum += s.inStockReserveMarketing),
        0
      ) || 0
    );
  }

  get totalInfluencer(): number {
    return (
      this.products?.reduce((sum, s) => (sum += s.inStockInfluencerB4A), 0) || 0
    );
  }
}
